/**
 * Created by H
 * User: huangcan
 * Date: 2020/3/31
 * Time: 10:36 上午
 * tips:
 */
import Export from 'components/Pop/Export/'

export default {
  components: {
    Export
  },
  methods: {
    /**
     * 打开导出弹窗
     */
    openExportPop() {
      this.$refs.excel._openPop()
    }
  }
}
